import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;
const functionsUrl = import.meta.env?.VITE_SUPABASE_FUNCTIONS_URL;

// Graceful fallback if env vars are missing
const getSupabaseClient = () => {
  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn("Supabase environment variables missing. Auth features will be disabled.");
    return null;
  }

  const clientOptions = {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
    },
  };

  if (functionsUrl) {
    clientOptions.functions = { url: functionsUrl };
  }

  return createClient(supabaseUrl, supabaseAnonKey, clientOptions);
};

export const supabase = getSupabaseClient();
